module.exports = __webpack_public_path__ + "img/bindez-new-logo.bcd4bb1d.png";